import { Component, OnInit } from '@angular/core';
import { DashboardQueryUnbalancedQuantityResultDto, DashboardService } from '@app/api/dmc';
import { ModalService } from '@app/core/services/modal.service';
import { ToastService } from '@app/core/services/toast.service';
import { AlertService } from '@app/core/services/alert.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-dashboard-dismiss-unbalanced-quantity',
  imports: [
    TranslatePipe,
  ],
  templateUrl: './dashboard-dismiss-unbalanced-quantity.component.html',
  styleUrl: './dashboard-dismiss-unbalanced-quantity.component.css'
})
export class DashboardDismissUnbalancedQuantityComponent implements OnInit {
  public elements: DashboardQueryUnbalancedQuantityResultDto[] = [];

  constructor(
    private readonly dashboardService: DashboardService,
    private readonly modalService: ModalService,
    private readonly toastService: ToastService,
    private readonly alertService: AlertService,
    private readonly translateService: TranslateService,
  ) {}

  public ngOnInit(): void {
    const message = this.translateService.instant(
      'dashboard.query.unbalancedquantity.remove.info',
      { count: this.elements.length }
    );
    this.alertService.open('modal', 'info', message);
  }

  public submit(): void {
    const ids = this.elements
      .map(e => e.meteringPointId)
      .filter((id): id is string => !!id);

    if (ids.length === 0) {
      return;
    }

    this.dashboardService.dashboardDismissUnbalancedQuantityPost({ meteringPointId: ids })
      .subscribe({
        next: () => {
          this.modalService.close();
          this.toastService.show('dashboard.query.unbalancedquantity.remove.success');
        },
        error: (err) => {
          console.error('Remove unbalanced quantity failed', err);
        }
      });
  }
}
